import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StartupService } from './startup.service';
import { Language } from '../models/language.model';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  readonly allowedLanguages = ['en', 'nl', 'fr', 'de', 'da', 'pl'];

  constructor(
    private translateService: TranslateService,
    private startupService: StartupService
  ) {
    if (!this.translateService.currentLang) {
      this.setLanguage('nl');
    }
    this.startupService.languageReceived$.subscribe((selected: Language) => {
      if (!!selected && !!selected.language) {
        this.setLanguage(selected.language);
      }
    });
  }

  get currentLanguage(): string {
    return this.translateService.currentLang;
  }

  setLanguage(language: string) {
    if (this.allowedLanguages.includes(language)) {
      this.translateService.use(language);
    }
  }
}
